import { FieldTypeEnum } from './field-type-enum'
import { MeteDataRes } from './mete-data-res'
import { TermReq } from './term-req'
import { ChildFieldResColumn } from './child-field-res-column'

export interface FieldResInterface {
  id: number
  groupId: number
  name: string
  label: string
  type: FieldTypeEnum
  description?: string
  groupWeight?: number
  weight: number
  parentId?: number
  defaultValue?: object
  rules?: object
  isShow?: boolean
  editable?: boolean
  metadata?: MeteDataRes
  editableFrontend: number
  isShowFrontend: number
  archivedWeight?: number
  archivedIsShow?: boolean
  options?: TermReq[]
  children?: ChildFieldResColumn[]
}

export class FieldRes implements FieldResInterface {
  id: number
  groupId: number
  name: string
  label: string
  type: FieldTypeEnum
  description?: string
  groupWeight?: number
  weight: number
  parentId?: number
  defaultValue?: object
  rules?: object
  isShow?: boolean
  editable?: boolean
  metadata?: MeteDataRes
  editableFrontend: number
  isShowFrontend: number
  archivedWeight?: number
  archivedIsShow?: boolean
  options?: TermReq[]
  children?: ChildFieldResColumn[]

  constructor(props: FieldResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      groupId: _groupId,
      name: _name,
      label: _label,
      type: _type,
      description: _description,
      groupWeight: _groupWeight,
      weight: _weight,
      parentId: _parentId,
      defaultValue: _defaultValue,
      rules: _rules,
      isShow: _isShow,
      editable: _editable,
      metadata: _metadata,
      editableFrontend: _editableFrontend,
      isShowFrontend: _isShowFrontend,
      archivedWeight: _archivedWeight,
      archivedIsShow: _archivedIsShow,
      options: _options,
      children: _children,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.groupId = _groupId
    this.name = _name
    this.label = _label
    this.type = _type
    this.description = _description
    this.groupWeight = _groupWeight
    this.weight = _weight
    this.parentId = _parentId
    this.defaultValue = _defaultValue
    this.rules = _rules
    this.isShow = _isShow
    this.editable = _editable
    this.metadata = _metadata ? new MeteDataRes(_metadata) : _metadata
    this.editableFrontend = _editableFrontend
    this.isShowFrontend = _isShowFrontend
    this.archivedWeight = _archivedWeight
    this.archivedIsShow = _archivedIsShow
    this.options = _options ? _options.map((i) => new TermReq(i)) : _options
    this.children = _children
      ? _children.map((i) => new ChildFieldResColumn(i))
      : _children
  }
}
